// src/components/SPanel/Home/homeEditStore.js
//
// Modul „Editează” al paginii principale: îl pornește butonul din bara de sus
// (pe telefon bara fixă a elevului, pe ecran lat bara din pagină) și îl
// folosește grila de widget-uri.

import { useSyncExternalStore } from "react";

let editing = false;
const listeners = new Set();

export function isHomeEditing() {
   return editing;
}

export function setHomeEditing(value) {
   const next = Boolean(value);
   if (next === editing) return;
   editing = next;
   listeners.forEach((listener) => listener());
}

export function toggleHomeEditing() {
   setHomeEditing(!editing);
}

function subscribe(listener) {
   listeners.add(listener);
   return () => listeners.delete(listener);
}

export function useHomeEditing() {
   return useSyncExternalStore(subscribe, isHomeEditing, isHomeEditing);
}
